import React, { Component } from 'react'
import {
    Form,
    Row,
    Col,
    Input, InputNumber, Select, Checkbox,
    Button, Table, Popconfirm, Modal,
    Icon,
    Collapse
} from 'antd';
import { uuid } from '../common/CommonFunc'
const FormItem = Form.Item;
const Panel = Collapse.Panel;
const Option = Select.Option;
const CheckboxGroup = Checkbox.Group;

const roleList = [
    { roleName: '省行领导', roleId: '1045209085940596736' },
    { roleName: '客户经理', roleId: '1045209085940596736' }
];// 调用服务取
const modalRoleListColumns = [
    {
        title: '角色名称', // 列头显示名称
        dataIndex: 'roleName' // 列数据在数据项中对应的 key
    }
];
let userList = [];
let modalUserList = [];

/**
 *添加审批人弹出窗
 *
 * @class UserModal
 * @extends {React.Component}
 */
class UserModal extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            modalShow: props.modalShow,
            title: props.title,
            loading: false
        }
    }

    // 创建表格绑定store（生成数据key）
    getTBData = (tData) => {
        if (!tData) {
            tData = [];
            return tData;
        }
        tData.forEach(element => {
            if (!element._key) element._key = uuid(8);
        })
        return tData;
    }
    // 角色列表行单击事件，record：当前行数据，index：行下标，从0开始
    roleOnRowClick = (record, index) => {
        return {
            onClick: () => { // 点击行
                console.log("列表行单击事件", record);
                // 调用服务查询当前角色下的员工列表
                userList = [
                    { empName: 'admin', userId: '1054707176943124480' },
                    { empName: '穆芳阁', userId: '1041971932871786502' },
                    { empName: '文阳', userId: '1041971932871786503' },
                    { empName: '王哲', userId: '1059760369871880192' }
                ];
                // 刷新员工列表
                modalUserList = this.getTBData(userList);
                this.setState({ loading: false });
            }
        };
    }
    // 输入参数modal确认按钮事件
    modalHandleOk = (e) => {
        this.props.parent.reload(); // 刷新审批人列表
        this.setState({
            modalShow: false,
        });
    }
    // 输入参数modal取消按钮事件
    modalHandleCancel = (e) => {
        this.setState({
            modalShow: false,
        });
    }

    render() {

        const modalRoleList = this.getTBData(roleList);
        const modalUserListColumns = [
            {
                title: '员工名称', // 列头显示名称
                dataIndex: 'empName' // 列数据在数据项中对应的 key
            }
        ];
        // 勾选事件
        const rowSelection = {
            onChange: (selectedRowKeys, selectedRows) => {
                console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                this.props.approvalUserList.splice(0, this.props.approvalUserList.length); // 清空数组，不改变引用地址
                this.props.approvalUserList.push.apply(this.props.approvalUserList, selectedRows); // 追加数组元素，不改变引用地址
            }
        };
        return (
            <Modal
                title={this.state.title}
                visible={this.state.modalShow}
                onOk={this.modalHandleOk}
                onCancel={this.modalHandleCancel}
                okText="确认"
                cancelText="取消"
                destroyOnClose
            >
                <Row gutter={16}>
                    <Col span={12}>
                        <Table size="small" rowKey={"_key"}
                            rowClassName={() => 'roleList-row'} // 表格行的类名
                            bordered // 是否展示外边框和列边框
                            dataSource={modalRoleList}
                            columns={modalRoleListColumns}
                            onRow={this.roleOnRowClick.bind(this)} // onRowClick：已弃用
                        />
                    </Col>
                    <Col span={12}>
                        <Table size="small" rowKey={"_key"}
                            rowClassName={() => 'userList-row'} // 表格行的类名
                            bordered // 是否展示外边框和列边框
                            dataSource={modalUserList}
                            columns={modalUserListColumns}
                            rowSelection={rowSelection}
                        />
                    </Col>
                </Row>
            </Modal>
        )
    }
}

export { UserModal };
export default UserModal;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiFlow/common/UserModal.js